const uk = {
  app: {
    name: 'Loyalty Platform',
    ownerConsole: 'Консоль власника',
    companyCabinet: 'Кабінет компанії',
  },
  common: {
    save: 'Зберегти',
    cancel: 'Скасувати',
    delete: 'Видалити',
    edit: 'Редагувати',
    add: 'Додати',
    create: 'Створити',
    close: 'Закрити',
    confirm: 'Підтвердити',
    search: 'Пошук',
    loading: 'Завантаження…',
    refresh: 'Оновити',
    back: 'Назад',
    next: 'Далі',
    previous: 'Попередня',
    all: 'Усі',
    yes: 'Так',
    no: 'Ні',
    actions: 'Дії',
    status: 'Статус',
    email: 'Email',
    password: 'Пароль',
    username: 'Логін',
    role: 'Роль',
    created: 'Створено',
    lastLogin: 'Останній вхід',
    never: 'Ніколи',
    you: 'Ви',
    noData: 'Даних поки немає',
    error: 'Щось пішло не так',
    saved: 'Збережено',
    pageOf: 'Сторінка {page} з {pages}',
    total: 'Усього: {count}',
    readOnly: 'Лише перегляд',
  },
  roles: {
    superadmin: 'Власник платформи',
    org_admin: 'Адміністратор',
    org_viewer: 'Спостерігач',
  },
  roleHints: {
    org_admin: 'Повний доступ до кабінету компанії',
    org_viewer: 'Бачить усе, але нічого не змінює',
  },
  nav: {
    support: 'Підтримка',
    groups: {
      platform: 'Платформа',
      business: 'Бізнес',
      system: 'Система',
      company: 'Компанія',
      engagement: 'Взаємодія',
      settings: 'Налаштування',
    },
    overview: 'Огляд',
    companies: 'Компанії',
    billing: 'Білінг',
    employees: 'Співробітники',
    analytics: 'Аналітика',
    notifications: 'Розсилки',
    logs: 'Журнал подій',
    security: 'Безпека',
    sql: 'SQL-консоль',
    systemSettings: 'Системні налаштування',
    audit: 'Журнал дій',
    billingNav: 'Білінг',
    home: 'Головна',
    restaurants: 'Заклади',
    branding: 'Застосунок',
    team: 'Команда',
    company: 'Компанія',
    myCompany: 'Моя компанія',
  },
  topbar: {
    theme: 'Тема',
    themeLight: 'Світла',
    themeDark: 'Темна',
    themeSystem: 'Як у системі',
    language: 'Мова',
    logout: 'Вийти',
    openCompany: 'Відкрити кабінет компанії',
    chooseCompany: 'Оберіть компанію',
    menu: 'Меню',
  },
  viewAs: {
    banner: 'Ви переглядаєте кабінет компанії «{name}» як власник платформи',
    exit: 'Повернутися до консолі',
  },
  login: {
    title: 'Вхід до панелі',
    subtitle: 'Керування програмою лояльності для співробітників',
    usernameLabel: 'Логін або email',
    passwordLabel: 'Пароль',
    submit: 'Увійти',
    submitting: 'Вхід…',
    invalid: 'Невірний логін або пароль',
    codeLabel: 'Код підтвердження',
    codeHint: 'Відкрийте застосунок-автентифікатор і введіть 6-значний код для цієї панелі.',
    codeInvalid: 'Невірний код. Перевірте, що час на телефоні встановлено автоматично.',
    back: 'Інший обліковий запис',
    sideTitle: 'Одна платформа — багато компаній',
    sideText: 'Співробітники, картки, аналітика й розсилки кожної компанії — окремо та під контролем.',
  },
  team: {
    title: 'Команда',
    subtitle: 'Хто має доступ до кабінету компанії',
    invite: 'Додати учасника',
    inviteTitle: 'Новий учасник команди',
    editTitle: 'Учасник команди',
    newPassword: 'Новий пароль',
    newPasswordHint: 'Залиште порожнім, щоб не змінювати',
    passwordHint: 'Щонайменше 8 символів',
    active: 'Активний',
    disabled: 'Доступ вимкнено',
    disable: 'Вимкнути доступ',
    enable: 'Увімкнути доступ',
    deleteConfirmTitle: 'Видалити учасника?',
    deleteConfirmText: '«{name}» втратить доступ до кабінету. Цю дію неможливо скасувати.',
    empty: 'У команді поки лише ви',
    emptyHint: 'Додайте колег: адміністраторів або спостерігачів, які лише переглядають дані.',
    created: 'Учасника додано',
    updated: 'Зміни збережено',
    deleted: 'Учасника видалено',
  },
  audit: {
    title: 'Журнал дій',
    subtitle: 'Хто, що і коли змінював у панелі',
    who: 'Хто',
    what: 'Дія',
    where: 'Компанія',
    when: 'Коли',
    result: 'Результат',
    fields: 'Поля',
    ok: 'Успішно',
    denied: 'Відхилено',
    failed: 'Помилка',
    empty: 'Дій поки немає',
    emptyHint: 'Тут з’являтимуться всі зміни, зроблені адміністраторами.',
    platform: 'Платформа',
    actions: {
      companyCreated: 'Створено компанію',
      companyUpdated: 'Змінено дані компанії',
      companyDeleted: 'Видалено компанію',
      brandingUpdated: 'Змінено оформлення застосунку',
      memberAdded: 'Додано учасника команди',
      memberUpdated: 'Змінено учасника команди',
      memberRemoved: 'Видалено учасника команди',
      paymentAdded: 'Додано оплату',
      paymentDeleted: 'Видалено оплату',
      documentUploaded: 'Завантажено документ',
      documentDeleted: 'Видалено документ',
      posChecked: 'Перевірка каси',
      employeeProfile: 'Змінено профіль співробітника',
      employeePassword: 'Змінено пароль співробітника',
      employeeDeleted: 'Видалено акаунт співробітника',
      employeeSynced: 'Оновлено співробітника з каси',
      massSync: 'Масова синхронізація з касою',
      pushSent: 'Надіслано розсилку',
      pushDeleted: 'Видалено розсилку',
      pushRuleCreated: 'Створено автоправило',
      pushRuleUpdated: 'Змінено автоправило',
      pushRuleDeleted: 'Видалено автоправило',
      restaurantSaved: 'Збережено заклад',
      restaurantDeleted: 'Скинуто налаштування закладу',
      ipBanned: 'Заблоковано IP',
      ipUnbanned: 'Розблоковано IP',
      ipWhitelisted: 'IP додано до білого списку',
      ipUnwhitelisted: 'IP прибрано з білого списку',
      sqlExecuted: 'Виконано SQL-запит',
      backupCreated: 'Створено резервну копію',
      cronChanged: 'Змінено розклад синхронізації',
      themeChanged: 'Змінено сезонну тему',
      fileUploaded: 'Завантажено файл',
    },
    methods: {
      POST: 'Створення',
      PUT: 'Оновлення',
      PATCH: 'Зміна',
      DELETE: 'Видалення',
    },
  },
  status: {
    company: { active: 'Активна', trial: 'Пробний період', past_due: 'Заборгованість', suspended: 'Заблокована' },
    pos: { ok: 'Каса працює', error: 'Помилка каси', degraded: 'Історія недоступна', unconfigured: 'Не налаштовано', unknown: 'Не перевірялась' },
    billing: { ok: 'Оплачено', due_soon: 'Скоро оплата', overdue: 'Прострочено', none: 'Без тарифу' },
  },
  plans: { trial: 'Trial', starter: 'Starter', pro: 'Pro', enterprise: 'Enterprise' },
  cycles: { monthly: 'Щомісяця', quarterly: 'Щокварталу', yearly: 'Щороку' },
  perMonth: '/міс',
  overview: {
    title: 'Огляд платформи',
    subtitle: 'Компанії, співробітники, оплати та стан кас — в одному місці',
    mrr: 'Регулярний дохід (MRR)',
    arr: 'за рік: {value}',
    companies: 'Компанії',
    companiesHint: '{active} активних',
    employees: 'Співробітники',
    employeesHint: '{registered} зареєстровано · +{new30} за 30 днів',
    spend: 'Витрати в закладах (30 днів)',
    spendHint: 'від минулих 30 днів',
    chartTitle: 'Витрати та нарахування',
    chartSubtitle: 'Сума по всіх компаніях за останні 30 днів',
    seriesSpend: 'Витрати в закладах',
    seriesTopup: 'Нараховано компаніями',
    companiesTitle: 'Стан компаній',
    companiesSubtitle: 'Каса, оплата та активність кожної компанії',
    activityTitle: 'Останні дії адміністраторів',
    allActivity: 'Увесь журнал',
    allCompanies: 'Усі компанії',
    alertOverdue: 'Прострочена оплата: {count}',
    alertOverdueText: 'Компанії, у яких минула дата наступної оплати.',
    alertPos: 'Проблеми з касою: {count}',
    alertPosText: 'Каса не налаштована або остання синхронізація завершилась помилкою.',
    alertDueSoon: 'Оплата протягом 7 днів: {count}',
    allGood: 'Усе в порядку: оплати вчасно, каси працюють',
    open: 'Переглянути',
  },
  companies: {
    title: 'Компанії',
    subtitle: 'Клієнти платформи: статус, тариф, каса та активність',
    new: 'Нова компанія',
    searchPlaceholder: 'Назва або код компанії',
    filterStatus: 'Статус',
    onlyProblems: 'Лише з проблемами',
    company: 'Компанія',
    plan: 'Тариф',
    employees: 'Співробітники',
    balance: 'Баланс карток',
    spend30: 'Витрати, 30 дн.',
    pos: 'Каса',
    billing: 'Оплата',
    empty: 'Компаній не знайдено',
    emptyHint: 'Змініть фільтри або створіть першу компанію.',
    createTitle: 'Нова компанія',
    createStepCompany: 'Компанія',
    createStepAdmin: 'Адміністратор компанії',
    createStepPlan: 'Тариф',
    name: 'Назва',
    slug: 'Системний ідентифікатор (slug)',
    slugHint: 'Латиниця, цифри, дефіс і підкреслення',
    companyCode: 'Код компанії',
    companyCodeHint: 'Співробітники вводять його в застосунку. Порожнє — з slug',
    companyCodeEditHint: 'Співробітники вводять його в застосунку',
    adminHint: 'Логін для входу заказчика в кабінет компанії. Можна додати пізніше в «Команді».',
    price: 'Ціна за період',
    cycle: 'Період оплати',
    currency: 'Валюта',
    created: 'Компанію створено',
  },
  company: {
    back: 'Усі компанії',
    openWorkspace: 'Відкрити кабінет',
    checkPos: 'Перевірити касу',
    suspend: 'Заблокувати',
    activate: 'Активувати',
    deleteCompany: 'Видалити компанію',
    deleteTitle: 'Видалити компанію?',
    deleteText: '«{name}» буде видалено разом із документами та оплатами. Компанію з співробітниками видалити не можна — лише заблокувати.',
    suspendTitle: 'Заблокувати компанію?',
    suspendText: 'Співробітники «{name}» одразу втратять доступ до застосунку, а адміністратори — до кабінету.',
    statusChanged: 'Статус змінено',
    deleted: 'Компанію видалено',
    tabs: {
      overview: 'Огляд',
      profile: 'Профіль',
      pos: 'Каса Servio',
      branding: 'Застосунок',
      team: 'Команда',
      billing: 'Тариф і оплати',
      documents: 'Документи',
      activity: 'Журнал',
      telegram: 'Telegram-бот',
    },
    kpi: {
      employees: 'Співробітники',
      employeesHint: '{registered} зареєстровано · {active7} активні за 7 днів',
      balance: 'Баланс карток',
      balanceHint: '{cards} активних карток',
      spend: 'Витрати, 30 днів',
      topup: 'Нараховано, 30 днів',
    },
    last30: 'Останні 30 днів',
    topVenues: 'Популярні заклади (30 днів)',
    visits: '{count} візитів',
    noVenues: 'Транзакцій за 30 днів не було',
    posCard: 'Каса',
    billingCard: 'Оплата',
    nextPayment: 'Наступна оплата',
    lastSync: 'Остання синхронізація',
    lastCheck: 'Остання перевірка',
    syncedCount: 'оновлено {synced}, помилок {failed}',
    txSync: 'Історія транзакцій',
    txSyncCount: 'карток {cards}, нових операцій {inserted}, помилок {failed}',
    posDown: 'Основна служба Servio недоступна з {since}: співробітники не можуть увійти, баланси не оновлюються.',
    historyDown: 'Каса відповідає, але системна служба Servio (історія транзакцій) недоступна з {since}. Нові транзакції не записуються.',
  },
  profile: {
    general: 'Основне',
    legal: 'Юридичні дані',
    contacts: 'Контакти',
    name: 'Публічна назва',
    legalName: 'Юридична назва',
    edrpou: 'ЄДРПОУ / ІПН',
    contactName: 'Контактна особа',
    contactPhone: 'Телефон',
    contactEmail: 'Email',
    city: 'Місто',
    address: 'Адреса',
    locations: 'Кількість закладів',
    notes: 'Внутрішні нотатки',
    notesHint: 'Бачите лише ви',
    regional: 'Регіональні налаштування',
    regionalHint: 'Впливають на звіти, аналітику й час автоматичних розсилок',
    timezone: 'Часовий пояс',
    timezoneHint: 'Час операцій у касі та автоматичні розсилки о 10:00 — за цим поясом',
    walletCurrency: 'Валюта карток',
    walletCurrencyHint: 'Як показувати баланси й суми в кабінеті компанії',
  },
  pos: {
    title: 'Підключення до Servio',
    subtitle: 'Кожна компанія працює зі своєю касою. Секретні поля після збереження не показуються.',
    posSection: 'Каса (POS API)',
    systemSection: 'Історія транзакцій (System API)',
    demoTitle: 'Демо-каса',
    demoOnHint: 'Компанія працює на вигаданих даних без справжньої каси: співробітники 380000000001–380000000003, картки, історія, QR. Для перевірки застосунку в App Store і показу клієнтам.',
    demoOffHint: 'Увімкніть, щоб компанія працювала на вигаданих даних без каси (перевірка в App Store, демонстрація клієнтам).',
    servio_url: 'Адреса POS API',
    servio_term_id: 'TermID терміналу',
    servio_code: 'Код терміналу',
    pos_code: 'POSCode',
    servio_url_sys: 'Адреса System API',
    system_term: 'System TermID',
    system_card: 'System CardCode',
    secretSaved: 'Збережено — залиште порожнім, щоб не змінювати',
    secretEmpty: 'Не задано',
    defaultHint: 'Для компанії за замовчуванням порожні поля беруться з .env сервера.',
    check: 'Перевірити підключення',
    checking: 'Перевіряємо…',
    checkPos: 'POS API',
    checkSystem: 'System API',
    checkOk: 'Підключено · {ms} мс',
    checkSkipped: 'Не налаштовано',
    saved: 'Налаштування каси збережено',
  },
  branding: {
    title: 'Оформлення застосунку',
    subtitle: 'Як застосунок виглядає для співробітників цієї компанії',
    colors: 'Кольори',
    primary: 'Основний',
    secondary: 'Додатковий',
    accent: 'Акцент',
    background: 'Фон',
    cardGradient: 'Градієнт картки',
    cornerRadius: 'Заокруглення',
    logoUrl: 'Логотип (URL)',
    headerTitle: 'Назва в застосунку',
    tabsTitle: 'Вкладки',
    tabsHint: 'Назви та видимість вкладок у нижньому меню',
    preview: 'Попередній перегляд',
    previewBalance: 'Баланс',
    previewCard: 'Персональна картка',
    saved: 'Оформлення збережено',
    tabNames: { wallets: 'Мої карти', notifications: 'Сповіщення', settings: 'Налаштування' },
  },
  billing: {
    title: 'Білінг',
    subtitle: 'Тарифи, оплати та заборгованості компаній',
    mrr: 'MRR',
    arr: 'ARR',
    overdue: 'Прострочено',
    dueSoon: 'Оплата за 7 днів',
    plansTitle: 'Тарифи компаній',
    paymentsTitle: 'Історія оплат',
    monthly: 'За місяць',
    nextDate: 'Наступна оплата',
    contract: 'Договір',
    contractNumber: 'Номер договору',
    contractDate: 'Дата договору',
    planSection: 'Тариф',
    addPayment: 'Додати оплату',
    amount: 'Сума',
    paymentDate: 'Дата оплати',
    periodStart: 'Період з',
    periodEnd: 'Період по',
    periodEndHint: 'Стане датою наступної оплати',
    method: 'Спосіб',
    invoice: 'Рахунок №',
    notes: 'Коментар',
    paymentStatus: 'Статус',
    methods: { bank_transfer: 'Банківський переказ', card: 'Картка', cash: 'Готівка', invoice: 'Рахунок' },
    paymentStatuses: { completed: 'Оплачено', pending: 'Очікується', refunded: 'Повернено' },
    deletePaymentTitle: 'Видалити оплату?',
    deletePaymentText: 'Запис про оплату буде видалено з історії.',
    paymentAdded: 'Оплату додано',
    paymentDeleted: 'Оплату видалено',
    noPayments: 'Оплат ще немає',
    period: 'Період',
  },
  documents: {
    title: 'Документи',
    subtitle: 'Договори, акти та рахунки компанії',
    upload: 'Завантажити',
    uploadTitle: 'Новий документ',
    docTitle: 'Назва',
    size: 'Розмір',
    type: 'Тип',
    file: 'Файл',
    types: { contract: 'Договір', act: 'Акт', invoice: 'Рахунок', other: 'Інше' },
    uploaded: 'Документ завантажено',
    deleted: 'Документ видалено',
    deleteTitle: 'Видалити документ?',
    deleteText: '«{name}» буде видалено без можливості відновлення.',
    empty: 'Документів ще немає',
    emptyHint: 'Завантажте договір або акт, щоб усе було під рукою.',
    download: 'Відкрити',
  },
  employees: {
    app: 'Застосунок',
    lastActive: 'Остання активність',
    appFilter: { all: 'Будь-яка версія', outdated: 'Не оновили застосунок', current: 'Актуальна версія', unknown: 'Без застосунку' },
    outdatedChip: 'Не оновили до {version}: {count}',
    outdated: 'Застаріла',
    upToDateBadge: 'Актуальна',
    legacyAppShort: 'Старий EnjoyFB',
    title: 'Співробітники',
    subtitleOwner: 'Усі співробітники всіх компаній платформи',
    subtitleCompany: 'Співробітники компанії, які користуються застосунком',
    searchPlaceholder: 'Ім’я або телефон',
    company: 'Компанія',
    employee: 'Співробітник',
    phone: 'Телефон',
    registered: 'Реєстрація',
    registeredYes: 'Зареєстрований',
    registeredNo: 'Не завершена',
    source: 'Джерело',
    sources: { all: 'Усі джерела', app: 'Застосунок', telegram: 'Telegram' },
    joined: 'Доданий',
    empty: 'Співробітників не знайдено',
    emptyHint: 'Співробітник з’являється тут після першого входу в застосунок.',
    profileTab: 'Профіль',
    cardsTab: 'Картки',
    historyTab: 'Історія',
    notificationsTab: 'Сповіщення',
    device: 'Пристрій',
    appVersion: 'Версія застосунку',
    legacyApp: 'старий застосунок EnjoyFB',
    updateAvailable: 'є оновлення {version}',
    upToDate: 'актуальна',
    lastLoginFrom: 'Останній вхід',
    registeredFrom: 'Реєстрація',
    firstName: 'Ім’я',
    lastName: 'Прізвище',
    middleName: 'По батькові',
    birthDate: 'Дата народження',
    sex: 'Стать',
    sexes: { 0: 'Не вказано', 1: 'Чоловіча', 2: 'Жіноча' },
    sexAll: 'Будь-яка стать',
    syncPos: 'Оновити з каси',
    synced: 'Дані оновлено з каси',
    resetPassword: 'Новий пароль',
    resetPasswordTitle: 'Новий пароль співробітника',
    resetPasswordHint: 'Повідомте співробітнику новий пароль особисто.',
    passwordChanged: 'Пароль змінено',
    deleteEmployee: 'Видалити акаунт',
    deleteTitle: 'Видалити акаунт співробітника?',
    deleteText: 'Акаунт, картки й історію в застосунку буде видалено. У касі Servio співробітник залишиться.',
    deleted: 'Акаунт видалено',
    profileSaved: 'Профіль збережено',
    noCards: 'Карток немає',
    noHistory: 'Транзакцій немає',
    noNotifications: 'Сповіщень немає',
    balance: 'Баланс',
    validUntil: 'Діє до',
    inactiveCard: 'Неактивна',
    topup: 'Нарахування',
    payment: 'Оплата',
    read: 'Прочитано',
    unread: 'Не прочитано',
  },
  logs: {
    title: 'Журнал подій',
    subtitle: 'Що відбувається на сервері: дії користувачів, помилки, синхронізація',
    tabs: { events: 'Події', errors: 'Помилки', performance: 'Швидкодія' },
    total: 'Усього подій',
    errors: 'Помилок',
    avgTime: 'Середній час',
    period: 'Період',
    periods: { '1': '24 години', '7': '7 днів', '30': '30 днів' },
    level: 'Рівень',
    levels: { info: 'Інфо', warn: 'Попередження', error: 'Помилка', fatal: 'Критична' },
    category: 'Категорія',
    categories: { user: 'Користувачі', admin: 'Адміністратори', system: 'Система', cron: 'Синхронізація', client: 'Застосунок', security: 'Безпека', ui: 'Інтерфейс' },
    searchPlaceholder: 'Пошук у тексті події',
    time: 'Час',
    event: 'Подія',
    user: 'Користувач',
    details: 'Деталі події',
    meta: 'Дані',
    topErrors: 'Найчастіші помилки',
    topUsers: 'Користувачі з найбільшою кількістю помилок',
    occurrences: '{count} разів',
    lastError: 'Остання помилка',
    slowest: 'Найповільніші операції',
    calls: 'Викликів',
    avg: 'Середнє',
    max: 'Максимум',
    empty: 'Подій не знайдено',
    noErrors: 'Помилок за період немає',
    trendTitle: 'Кількість подій',
    seriesEvents: 'Події',
  },
  security: {
    title: 'Безпека',
    subtitle: 'Атаки на сервер, заблоковані та довірені IP-адреси',
    tabs: { attacks: 'Атаки', banned: 'Заблоковані IP', whitelist: 'Білий список' },
    totalAttacks: 'Усього атак',
    today: 'Сьогодні',
    banned: 'Заблоковано IP',
    topTypes: 'Типи атак',
    ip: 'IP-адреса',
    type: 'Тип',
    request: 'Запит',
    when: 'Коли',
    reason: 'Причина',
    attempts: 'Спроб',
    filterIp: 'Фільтр за IP',
    ban: 'Заблокувати IP',
    banTitle: 'Заблокувати IP-адресу',
    unban: 'Розблокувати',
    whitelistAdd: 'Додати до білого списку',
    whitelistTitle: 'Довірена IP-адреса',
    whitelistHint: 'Запити з цієї адреси не перевіряються WAF і не блокуються.',
    remove: 'Прибрати',
    isBanned: 'Заблоковано',
    banned_ok: 'IP заблоковано',
    unbanned_ok: 'IP розблоковано',
    whitelisted_ok: 'IP додано до білого списку',
    removed_ok: 'IP прибрано з білого списку',
    unbanConfirm: 'Розблокувати {ip}?',
    unbanText: 'Запити з цієї адреси знову будуть прийматися.',
    removeConfirm: 'Прибрати {ip} з білого списку?',
    removeText: 'Запити з цієї адреси знову перевірятимуться WAF.',
    emptyAttacks: 'Атак не зафіксовано',
    emptyBanned: 'Заблокованих адрес немає',
    emptyWhitelist: 'Білий список порожній',
    manualBan: 'Ручне блокування',
  },
  sql: {
    title: 'SQL-консоль',
    subtitle: 'Пряма робота з базою даних. Будьте обережні: зміни незворотні.',
    tables: 'Таблиці',
    columns: 'Колонки',
    query: 'Запит',
    run: 'Виконати',
    running: 'Виконується…',
    rows: '{count} рядків',
    changes: 'Змінено рядків: {count}',
    browse: 'Переглянути',
    hint: 'Ctrl + Enter — виконати',
    writeTitle: 'Виконати змінюючий запит?',
    writeText: 'Запит змінює дані в базі (не SELECT). Переконайтеся, що є резервна копія.',
    writeConfirm: 'Виконати',
    emptyResult: 'Запит виконано, рядків немає',
    pickTable: 'Оберіть таблицю або напишіть запит',
    limited: 'Показано перші {count} рядків',
  },
  system: {
    title: 'Системні налаштування',
    subtitle: 'Синхронізація з касами, резервні копії, сертифікат і сезонна тема',
    sync: 'Синхронізація з касами',
    syncHint: 'Як часто сервер оновлює картки всіх співробітників з кас компаній.',
    interval: 'Інтервал, хвилин',
    syncNow: 'Синхронізувати зараз',
    syncStarted: 'Синхронізацію запущено',
    syncProgress: 'Виконано {percent}%',
    lastSync: 'Остання синхронізація',
    nextSync: 'Наступна',
    backup: 'Резервна копія',
    backupHint: 'Архів бази, файлів і налаштувань завантажується в приватний репозиторій GitHub і надсилається в Telegram. Автоматично — щодня о 01:00.',
    backupNow: 'Створити копію зараз',
    backupDone: 'Резервну копію створено',
    ssl: 'SSL-сертифікат',
    sslDomain: 'Домен',
    sslValidTo: 'Діє до',
    sslDays: 'Залишилось днів',
    sslIssuer: 'Видавець',
    sslRenew: 'Оновити сертифікат',
    sslUnavailable: 'Не вдалося прочитати сертифікат',
    sslOutput: 'Журнал оновлення',
    appVersion: 'Версії застосунку',
    storeRefresh: 'Перевірити App Store',
    storeVersion: 'Зараз в App Store: версія {version}',
    storeReleased: 'вийшла {date}',
    storeChecked: 'перевірено {at}',
    storeUnknown: 'Версію з App Store ще не отримано',
    autoLatest: 'Актуальна версія — автоматично з App Store',
    autoLatestHint: 'Вийшла нова версія — застосунок сам запропонує оновитися (один раз на кожну версію)',
    latestAutoHint: 'Береться з App Store',
    storeUrlAuto: 'Якщо порожньо — {url}',
    appVersionHint: 'Старіші версії iOS-застосунку просять оновитися. Порожнє поле — без обмежень.',
    minVersion: 'Мінімальна версія',
    minVersionHint: 'Нижче — оновлення обовʼязкове',
    latestVersion: 'Актуальна версія',
    latestVersionHint: 'Нижче — пропонуємо оновитися',
    appStoreUrl: 'Посилання на App Store',
    seasonal: 'Сезонна тема застосунку',
    seasonalHint: 'Святкове оформлення для всіх компаній (сніг, емодзі).',
    themes: { standard: 'Стандартна', new_year: 'Новорічна' },
    themeSaved: 'Тему змінено',
    saved: 'Налаштування збережено',
  },
  servio: {
    title: 'Зв’язок із Servio',
    subtitle: 'Перевірка щогодини і при кожному зверненні до каси',
    problems: 'Проблеми зі зв’язком: {count}',
    pos: 'Основна служба',
    posHint: 'Вхід співробітників, баланси, QR-коди',
    system: 'Системна служба',
    systemHint: 'Історія транзакцій',
    states: { ok: 'Працює', down: 'Недоступна', unknown: 'Не перевірялась' },
    checked: 'перевірено {time}',
    since: 'недоступна з {time}',
    lastCheck: 'Остання перевірка',
    checkNow: 'Перевірити',
    noCompanies: 'Немає компаній з підключеною касою',
  },
  twofa: {
    title: 'Двофакторний вхід',
    subtitle: 'Код із телефону на додачу до пароля',
    status: 'Стан',
    on: 'Увімкнено',
    off: 'Вимкнено',
    intro: 'Навіть якщо пароль дізнаються, без вашого телефону увійти не вийде. Знадобиться застосунок Google Authenticator, 1Password або аналогічний.',
    start: 'Увімкнути',
    step1: 'Відскануйте QR-код у застосунку-автентифікаторі (або введіть ключ вручну).',
    step2: 'Введіть 6-значний код, який покаже застосунок.',
    qrAlt: 'QR-код для застосунку-автентифікатора',
    confirm: 'Підтвердити й увімкнути',
    enabled: 'Двофакторний вхід увімкнено',
    disable: 'Вимкнути',
    disableHint: 'Щоб вимкнути, введіть поточний код із застосунку-автентифікатора.',
    disabled: 'Двофакторний вхід вимкнено',
    reset: 'Скинути 2FA',
    resetHint: 'Якщо колега втратив телефон. Усі його сесії завершаться.',
  },
  invites: {
    tab: 'Запрошення',
    invite: 'Запросити',
    inviteTitle: 'Запросити співробітника',
    inviteHint: 'Персональне посилання на один номер — для реєстрації в застосунку',
    phoneHint: 'Номер, який записаний у касі',
    name: 'Ім’я (необов’язково)',
    namePlaceholder: 'Щоб привітати на сторінці запрошення',
    validity: 'Діє',
    days: { 1: '1 день', 3: '3 дні', 7: '7 днів', 14: '14 днів', 30: '30 днів' },
    create: 'Створити посилання',
    readyTitle: 'Запрошення готове',
    another: 'Ще одне',
    link: 'Посилання',
    linkHint: 'Надішліть у Telegram, Viber або SMS. Відкриється застосунок із вже введеними компанією й номером.',
    qrAlt: 'QR-код запрошення',
    qrHint: 'Або покажіть QR-код — співробітник відскановує його камерою телефона',
    downloadQr: 'Завантажити QR (PNG)',
    title: 'Запрошення',
    created: 'Створено',
    validUntil: 'Діє до',
    copyLink: 'Скопіювати посилання',
    showQr: 'Показати QR-код',
    revoke: 'Скасувати',
    revokeTitle: 'Скасувати запрошення?',
    revokeText: 'Посилання для {phone} перестане працювати.',
    revoked: 'Запрошення скасовано',
    statuses: { pending: 'Очікує', used: 'Використано', expired: 'Минув термін', revoked: 'Скасовано' },
    empty: 'Запрошень ще немає',
    emptyHint: 'Надішліть співробітнику посилання — він зареєструється за хвилину.',
    modeTitle: 'Реєстрація лише за запрошенням',
    modeInviteHint: 'Новий співробітник реєструється тільки за персональним посиланням на свій номер. Ніхто сторонній не займе чужий акаунт.',
    modeOpenHint: 'Зараз зареєструватися може будь-хто, хто знає код компанії й номер співробітника. Рекомендуємо увімкнути.',
  },
  home: {
    paymentSoon: 'Через {days} дн. — оплата підписки',
    paymentToday: 'Сьогодні — день оплати підписки',
    paymentOverdue: 'Оплата підписки прострочена на {days} дн.',
    paymentDetails: 'Дата оплати {date}, сума {amount}. Якщо вже оплатили — дякуємо!',
    greeting: 'Вітаємо, {name}',
    subtitle: 'Коротко про те, як співробітники користуються застосунком',
    companyCode: 'Код компанії',
    companyCodeHint: 'Співробітники вводять цей код у застосунку під час першого входу.',
    copy: 'Скопіювати',
    copied: 'Скопійовано',
    howToJoin: 'Як співробітнику почати',
    steps: {
      1: 'Встановити застосунок і ввести код компанії',
      2: 'Увійти за номером телефону, який є в касі',
      3: 'Створити пароль — картка з’явиться автоматично',
    },
    quick: 'Швидкі дії',
    quickPush: 'Надіслати розсилку',
    quickBranding: 'Налаштувати застосунок',
    quickTeam: 'Запросити колегу',
    quickVenues: 'Оформити заклади',
    recent: 'Останні дії команди',
    noRecent: 'Дій ще не було',
    posOk: 'Дані з каси оновлюються',
    posProblem: 'Проблема з касою — ми вже знаємо і працюємо над цим',
    posHistoryDown: 'Баланси оновлюються, але нові транзакції тимчасово не надходять в історію — ми вже працюємо над цим',
    posNotConfigured: 'Касу ще не підключено. Зверніться до підтримки.',
  },
  analytics: {
    title: 'Аналітика',
    subtitleCompany: 'Витрати співробітників, нарахування та популярні заклади',
    subtitleOwner: 'Витрати та нарахування по всіх компаніях або обраній',
    period: 'Період',
    periods: { 7: '7 днів', 30: '30 днів', 90: '90 днів', 365: 'Рік' },
    allCompanies: 'Усі компанії',
    export: 'Експорт CSV',
    exported: 'Файл завантажено',
    spend: 'Витрати в закладах',
    checks: 'Чеків',
    avgCheck: 'Середній чек',
    topup: 'Нараховано компанією',
    spenders: 'Користувались карткою',
    spendersHint: 'з {cards} карток',
    vsPrev: 'від попереднього періоду',
    engagement: 'Залученість',
    inApp: 'У застосунку',
    inAppHint: 'зареєстровано з {total}',
    active7: 'Активні за 7 днів',
    idle: 'Без витрат за період',
    idleHint: 'карток не використовувались',
    negative: 'Мінусовий баланс',
    negativeHint: 'разом {sum}',
    trend: 'Витрати та нарахування по днях',
    venues: 'Заклади',
    venue: 'Заклад',
    visits: 'Візити',
    sum: 'Сума',
    share: 'Частка',
    people: 'Співробітників',
    lastVisit: 'Останній візит',
    topEmployees: 'Найактивніші співробітники',
    employee: 'Співробітник',
    heatmap: 'Коли співробітники ходять у заклади',
    heatmapHint: 'Кількість чеків за днем тижня та годиною',
    fewer: 'Менше',
    more: 'Більше',
    weekdays: { 0: 'Нд', 1: 'Пн', 2: 'Вт', 3: 'Ср', 4: 'Чт', 5: 'Пт', 6: 'Сб' },
    heatCell: '{day}, {hour}:00 — {count} чеків',
    byCompany: 'По компаніях',
    noData: 'За цей період операцій немає',
    unknown: 'Без імені',
  },
  support: {
    title: 'Підтримка',
    subtitle: 'Звернення співробітників з усіх компаній — із застосунку і Telegram-бота',
    botSettings: 'Бот підтримки',
    tabs: { open: 'Відкриті', new: 'Нові', in_progress: 'В роботі', resolved: 'Вирішені', all: 'Усі' },
    status: { new: 'Нова', in_progress: 'В роботі', resolved: 'Вирішена' },
    searchPlaceholder: 'Ім’я, телефон або #номер',
    company: 'Компанія',
    allCompanies: 'Усі компанії',
    empty: 'Заявок немає',
    emptyHint: 'Тут з’являться звернення співробітників.',
    pick: 'Оберіть заявку',
    pickHint: 'Переписка, пристрій і помилки застосунку — праворуч.',
    you: 'Ви',
    takeInWork: 'В роботу',
    resolve: 'Вирішено',
    noDevice: 'Пристрій невідомий',
    created: 'Створено',
    appErrors: 'Помилки застосунку: {count}',
    replyPlaceholder: 'Відповідь співробітнику — прийде в Telegram і push у застосунок',
    replyHint: 'Ctrl + Enter — надіслати',
    send: 'Надіслати',
    sent: 'Відповідь надіслано',
    notDelivered: 'Збережено, але співробітник зараз не на зв’язку в Telegram',
    setup: {
      title: 'Підключіть бота підтримки',
      text: 'Співробітники писатимуть у Telegram-бот (кнопка в застосунку), а заявки з’являтимуться тут і у вашому Telegram.',
      step1: 'Відкрийте @BotFather у Telegram і надішліть /newbot.',
      step2: 'Введіть назву (наприклад, «Spoilty Підтримка») і username, що закінчується на bot (наприклад, SpoiltySupportBot).',
      step3: 'BotFather надішле токен вигляду 1234567890:AA… — скопіюйте його.',
      step4: 'Вставте токен нижче й натисніть «Підключити». Потім підключіть свій Telegram, щоб отримувати заявки.',
      token: 'Токен бота',
      connect: 'Підключити',
      connected: 'Бот @{name} підключено',
    },
    owner: {
      title: 'Підключіть свій Telegram',
      text: 'Натисніть кнопку — відкриється бот, натисніть «Start». Після цього заявки приходитимуть вам у Telegram, а відповідати можна reply на картку заявки.',
      connect: 'Підключити мій Telegram',
      check: 'Перевірити',
    },
    settings: {
      bot: 'Бот',
      owner: 'Заявки надходять',
      ownerMissing: 'Telegram власника не підключено',
      replace: 'Замінити бота — вставте токен іншого бота:',
      disconnect: 'Відключити бота',
      disconnectConfirm: 'Відключити бота підтримки? Співробітники не зможуть писати, доки ви не підключите його знову.',
    },
  },
  tgBot: {
    title: 'Telegram-бот для співробітників',
    intro: 'Для співробітників з Android або тих, хто не хоче ставити застосунок: у Telegram-боті компанії — картки, баланс, QR-код для оплати, історія операцій і сповіщення про поповнення. Бот належить вашій компанії й має вашу назву.',
    stepsTitle: 'Як налаштувати бота',
    steps: {
      s1: { title: 'Відкрийте @BotFather у Telegram', text: 'Це офіційний бот Telegram для створення ботів (із синьою галочкою). Натисніть «Start».' },
      s2: { title: 'Надішліть команду /newbot', text: 'BotFather попросить назву бота — її бачать співробітники, наприклад «Картки Bravo».' },
      s3: { title: 'Придумайте username', text: 'Латиницею, без пробілів, обов’язково закінчується на bot — наприклад BravoCardsBot. Якщо зайнято, BotFather попросить інший.' },
      s4: { title: 'Скопіюйте токен', text: 'BotFather надішле повідомлення з токеном вигляду 1234567890:AAH… Нікому його не пересилайте — це ключ від бота.' },
      s5: { title: 'За бажанням — логотип', text: 'Команда /setuserpic → оберіть бота → надішліть логотип компанії (квадратний). Опис і команди сервер налаштує сам.' },
      s6: { title: 'Вставте токен сюди й натисніть «Підключити»', text: 'Сервер перевірить токен, підключить бота й покаже посилання та QR-код, які можна розіслати співробітникам.' },
    },
    token: 'Токен бота',
    connect: 'Підключити',
    connected: 'Бот @{name} підключено',
    connectedTitle: 'Бот підключено',
    linked: 'Підключилися співробітників: {count}',
    howEmployees: 'Співробітник відкриває бота, натискає «Start» і ділиться номером телефону. Якщо номер є серед співробітників вашої компанії — бачить свої картки. Сповіщення про поповнення приходять у бот тим, хто не користується застосунком.',
    inviteText: 'У {company} є Telegram-бот для карток: баланс, QR-код для оплати та історія.\nВідкрийте {link}, натисніть «Start» і поділіться номером телефону.',
    copyInvite: 'Скопіювати запрошення',
    copied: 'Запрошення скопійовано',
    open: 'Відкрити бота',
    qrTitle: 'QR-код бота',
    qrHint: 'Роздрукуйте або покажіть співробітникам — камера телефону відкриє бота.',
    downloadQr: 'Завантажити QR',
    replace: 'Замінити бота — вставте токен іншого бота:',
    disconnect: 'Відключити бота',
    disconnectConfirm: 'Бот перестане відповідати співробітникам, доки ви не підключите його знову. Самого бота в Telegram не буде видалено.',
    viewOnly: 'Підключити бота може адміністратор компанії.',
  },
  push: {
    cardEvents: {
      title: 'Сповіщення про картку',
      hint: 'Надсилаються автоматично, коли каса оновлює баланс картки (перевірка раз на годину). Вимкнені не потрапляють ні в push, ні у стрічку застосунку.',
      types: { top_up: 'Поповнення картки', new_card: 'Нова картка', negative_balance: 'Баланс пішов у мінус' },
      minAmount: 'Мінімальна сума, ₴',
      minAmountHint: 'Менші поповнення (наприклад, повернення) — без сповіщення. 0 — про всі.',
      placeholders: 'Підстановки: {name} — ім’я співробітника, {card} — номер картки, {amount} — сума поповнення, {balance} — баланс після зміни.',
      quiet: 'Тихі години',
      quietFrom: 'З',
      quietTo: 'До',
      quietHint: 'У цей час push не надсилається: запис одразу з’являється у стрічці застосунку, а push прийде о закінченні тихих годин.',
      sample: { name: 'Олена' },
    },
    title: 'Розсилки',
    subtitle: 'Повідомлення співробітникам у застосунок і push-сповіщення',
    tabs: { compose: 'Нова розсилка', history: 'Історія', rules: 'Автоматичні' },
    company: 'Компанія',
    pickCompany: 'Оберіть компанію',
    pickCompanyHint: 'Розсилка надсилається співробітникам однієї компанії.',
    audience: 'Кому',
    audiences: { all: 'Усім', male: 'Чоловікам', female: 'Жінкам', phones: 'За номерами' },
    phones: 'Номери телефонів',
    phonesHint: 'Кожен номер з нового рядка або через кому, у форматі 380…',
    recipients: '{count} отримувачів',
    titleField: 'Заголовок',
    message: 'Текст',
    image: 'Зображення',
    imageHint: 'Необов’язково. JPG або PNG до 10 МБ.',
    removeImage: 'Прибрати',
    ttl: 'Актуальність',
    ttlOptions: { '': 'Без обмеження', 6: '6 годин', 24: '1 день', 72: '3 дні', 168: 'Тиждень' },
    ttlHint: 'Якщо телефон був вимкнений довше — push не прийде, але повідомлення залишиться в застосунку.',
    preview: 'Як це побачать',
    previewTitle: 'Заголовок повідомлення',
    previewMessage: 'Текст повідомлення',
    now: 'зараз',
    send: 'Надіслати',
    confirmTitle: 'Надіслати розсилку?',
    confirmText: 'Повідомлення отримають {count} співробітників. Скасувати після надсилання не вийде.',
    sent: 'У стрічку застосунку: {count}, push доставлено: {pushed}',
    noRecipients: 'Немає співробітників для цієї розсилки',
    sentAt: 'Надіслано',
    delivered: 'Отримали',
    readRate: 'Прочитали',
    deleteTitle: 'Видалити розсилку?',
    deleteText: 'Повідомлення зникне зі стрічки сповіщень у застосунку співробітників.',
    deleted: 'Розсилку видалено',
    emptyHistory: 'Розсилок ще не було',
    rulesIntro: 'Автоматичні розсилки надсилаються щодня о 10:00 (Київ) тим співробітникам, кого вони стосуються.',
    newRule: 'Нове правило',
    editRule: 'Правило розсилки',
    ruleType: 'Подія',
    ruleTypes: { birthday: 'День народження', negative_balance: 'Мінусовий баланс' },
    ruleTypeHints: {
      birthday: 'У день народження співробітника.',
      negative_balance: 'Нагадування, поки баланс мінусовий; не частіше разу на тиждень. Перше сповіщення про мінус система надсилає сама.',
    },
    placeholders: 'Можна вставити {name} — ім’я та {balance} — баланс картки.',
    active: 'Увімкнено',
    paused: 'Вимкнено',
    lastRun: 'Остання відправка',
    todayWillGet: 'Сьогодні отримали б: {count}',
    checkToday: 'Хто отримає сьогодні',
    ruleSaved: 'Правило збережено',
    ruleDeleted: 'Правило видалено',
    deleteRuleTitle: 'Видалити правило?',
    deleteRuleText: 'Автоматична розсилка «{name}» більше не надсилатиметься.',
    emptyRules: 'Автоматичних розсилок ще немає',
    emptyRulesHint: 'Наприклад, привітання з днем народження.',
    uploadFailed: 'Не вдалося завантажити зображення',
    systemTitle: 'Автоматичні сповіщення за 30 днів',
    systemHint: 'Надсилаються самі, коли з каси приходять зміни по картці співробітника.',
    systemTypes: { new_card: 'Нова картка', top_up: 'Поповнення', negative_balance: 'Баланс пішов у мінус' },
    systemRead: 'прочитано {pct}%',
  },
  venues: {
    title: 'Заклади',
    subtitle: 'Як заклади виглядають у застосунку: назва, логотип і графік роботи',
    search: 'Пошук закладу',
    fromPos: 'Назва в касі',
    displayName: 'Назва в застосунку',
    schedule: 'Графік роботи',
    schedulePlaceholder: 'Пн–Пт 09:00–22:00, Сб–Нд 10:00–23:00',
    scheduleHint: 'За графіком застосунок показує «Відчинено», «Скоро зачиниться», «Зачинено».',
    scheduleUnderstood: 'У застосунку',
    scheduleNotUnderstood: 'Не вдалося розібрати графік — у застосунку буде лише текст, без статусу «Відчинено/Зачинено». Приклад: Пн–Пт 09:00–22:00, Сб–Нд 10:00–23:00',
    allDay: 'цілодобово',
    top: {
      title: 'Найпопулярніший заклад',
      hint: 'У застосунку він стоїть першим у списку, із золотою рамкою та статистикою візитів. Рахується за візитами співробітників за обраний період, або оберіть заклад вручну.',
      now: 'Зараз у застосунку',
      none: 'Поки немає: за цей період ще не було візитів.',
      visits: '{count} візитів',
      days: 'за {count} днів',
      allTime: 'за весь час',
      period: 'Період',
      leader: 'Лідер',
      auto: 'Автоматично',
      autoWith: 'Автоматично — {name}',
      manualBadge: 'Обрано вручну',
    },
    dayOff: 'вихідний',
    day1: 'Пн', day2: 'Вт', day3: 'Ср', day4: 'Чт', day5: 'Пт', day6: 'Сб', day7: 'Нд',
    servioId: 'ID у Servio',
    logo: 'Логотип',
    logoHint: 'PNG, JPG, SVG або WebP до 1 МБ. Найкраще — квадратний, з фоном. SVG автоматично перетворюється на PNG.',
    logoLightWarning: 'Логотип світлий на прозорому фоні — на білій плитці в застосунку його майже не видно. Краще завантажте версію з кольоровим фоном.',
    logoTooBig: 'Файл завеликий — максимум 1 МБ',
    uploadLogo: 'Завантажити логотип',
    removeLogo: 'Прибрати логотип',
    notConfigured: 'Не оформлено',
    configured: 'Оформлено',
    saved: 'Заклад збережено',
    reset: 'Скинути оформлення',
    resetTitle: 'Скинути оформлення закладу?',
    resetText: 'Логотип, назва й графік «{name}» будуть видалені. Заклад залишиться в списку з назвою з каси.',
    resetDone: 'Оформлення скинуто',
    empty: 'Закладів ще немає',
    emptyHint: 'Заклад з’являється тут після першої операції співробітника в ньому.',
    filters: { all: 'Усі', configured: 'Оформлені', new: 'Не оформлені', service: 'Службові' },
    inApp: 'У застосунку',
    txCount: 'Операцій: {count}',
    lastTx: 'остання {date}',
    alsoInPos: 'Також у касі',
    merge: 'Обʼєднати',
    mergeTitle: 'Обʼєднати з «{name}»',
    mergeHint: 'Позначте назви з каси, які означають цей самий заклад (старі назви, інше написання). Операції, візити й аналітика рахуватимуться разом, а в історії буде один логотип і назва. Дані в касі не змінюються.',
    mergeConfirm: 'Обʼєднати ({count})',
    merged: 'Обʼєднано: {count}',
    unmerge: 'Відʼєднати {name}',
    unmerged: 'Назву відʼєднано',
    markService: 'Службове: не заклад (напр. центральний офіс, де поповнюють картки)',
    markedService: 'Позначено як службове',
    unmarkService: 'Повернути',
    unmarkedService: 'Повернуто до закладів',
    serviceHint: 'Назви з каси, які не є закладами — наприклад, центральний офіс, де поповнюють картки. Не показуються в застосунку й аналітиці закладів.',
    serviceEmpty: 'Службових назв немає',
    tabTitle: 'Вкладка «Заклади» в застосунку',
    tabOnHint: 'Співробітники бачать список закладів з адресами, картою, графіком і телефоном. Приховані заклади не показуються.',
    tabOffHint: 'Увімкніть, щоб співробітники бачили в застосунку, де можна скористатися карткою: адреси, карта, графік роботи.',
    noAddress: 'Адресу не вказано',
    hidden: 'Прихований',
    category: 'Тип закладу',
    categoryPlaceholder: 'Кафе, ресторан, кав’ярня…',
    address: 'Адреса',
    addressPlaceholder: 'Київ, вул. Хрещатик, 1',
    coords: 'Координати на карті',
    coordsHint: 'Скопіюйте з Google Maps: правий клік по місцю → перший рядок, напр. 50.4501, 30.5234',
    coordsInvalid: 'Координати у форматі «50.4501, 30.5234»',
    openMap: 'Перевірити на карті',
    phone: 'Телефон',
    description: 'Опис',
    descriptionPlaceholder: 'Що є в меню, де знайти, чи можна взяти з собою…',
    menuUrl: 'Посилання на меню',
    menuUrlHint: 'Сайт, PDF або сторінка з меню — у застосунку з’явиться кнопка «Меню»',
    openMenu: 'Відкрити',
    showInApp: 'Показувати в застосунку',
    showInAppHint: 'Вимкніть для закладів, які не мають бути у списку (напр. службова кухня)',
    sortOrder: 'Порядок у списку',
    sortOrderHint: 'Менше число — вище',
  },
  reminders: {
    title: 'Нагадування про оплату',
    subtitle: 'Вам — у Telegram, клієнтам — на пошту: коли наближається або прострочена абонплата',
    channelTelegram: 'Telegram-бот власника',
    channelTelegramHint: 'Не налаштовано: TELEGRAM_BOT_TOKEN і TELEGRAM_CHAT_ID у .env сервера',
    channelEmail: 'Пошта для листів клієнтам',
    channelEmailHint: 'Не налаштовано: EMAIL_HOST, EMAIL_USER, EMAIL_PASS у .env сервера',
    hour: 'Час надсилання',
    hourHint: 'Щодня, за київським часом',
    ownerTitle: 'Мені в Telegram',
    ownerHint: 'Одне повідомлення-зведення: у кого скоро оплата і хто прострочив',
    daysBefore: 'За скільки днів нагадувати',
    daysBeforeHint: 'Через кому, 0 — у день оплати. Наприклад: 7, 3, 1, 0',
    overdueDaily: 'Щодня, поки прострочено',
    overdueDailyHint: 'Нагадувати кожного дня, доки оплату не внесено',
    testTelegram: 'Надіслати тестове зведення',
    customerTitle: 'Клієнтам на пошту',
    customerHint: 'Лист на пошту компанії (контактна або окрема пошта для рахунків у картці компанії)',
    overdueDays: 'Після прострочення, через днів',
    overdueDaysHint: 'Наприклад: 1, 3, 7 — на 1-й, 3-й і 7-й день прострочення',
    placeholders: 'У тексті можна використати:',
    beforeLetter: 'Лист до дати оплати',
    overdueLetter: 'Лист після прострочення',
    subject: 'Тема',
    body: 'Текст листа',
    testCompany: 'Компанія для прикладу',
    testTo: 'Надіслати приклад на',
    testBefore: 'Приклад: до оплати',
    testOverdue: 'Приклад: прострочено',
    testSent: 'Тестове повідомлення надіслано',
    companiesTitle: 'Найближчі оплати',
    noCompanies: 'Немає компаній з тарифом і датою оплати',
    noCompaniesHint: 'Вкажіть ціну і дату наступної оплати у вкладці «Тариф і оплати» компанії',
    when: 'Коли',
    today: 'сьогодні',
    inDays: 'через {days} дн.',
    overdueDaysLabel: 'прострочено {days} дн.',
    recipient: 'Пошта для листів',
    noEmail: 'немає пошти',
    emailsOn: 'Листи клієнту',
    emailsOnHint: 'Вимкніть, якщо компанії не треба надсилати нагадування (напр. оплата за договором)',
    billingEmail: 'Пошта для рахунків',
    billingEmailHint: 'Якщо порожньо — на контактну пошту ({email})',
    logTitle: 'Журнал надсилань',
    logEmpty: 'Нагадувань ще не надсилали',
    sentAt: 'Коли',
    channel: 'Куди',
    sent: 'Надіслано',
    failed: 'Помилка',
    preview: 'Що піде сьогодні',
    previewTitle: 'Нагадування на сьогодні',
    previewOwner: 'Вам у Telegram',
    previewCustomers: 'Клієнтам на пошту',
    previewNone: 'Нічого',
    previewNote: 'Автоматично це надсилається щодня в обраний час. Один і той самий лист клієнту двічі не надсилається.',
    sendNow: 'Надіслати зараз',
    runDone: 'Готово: у Telegram — {owner} компаній, листів — {sent}, помилок — {failed}',
  },
  reliability: {
    title: 'Надійність',
    subtitle: 'Щоденна копія бази з перевіркою відновлення і стеження за доступністю сайту. Про проблеми — повідомлення вам у Telegram',
    checkNow: 'Зробити й перевірити копію',
    backupTitle: 'Резервна копія бази',
    backupNever: 'Ще не перевірялась',
    backupOk: 'Копію створено й перевірено',
    backupFailed: 'Копія не пройшла перевірку',
    backupOkAt: 'Перевірена {at}: відкривається, дані цілі',
    backupFailedAt: 'Помилка {at}',
    backupCounts: 'Співробітників {users}, карток {cards}, операцій {tx}',
    kept: 'зберігається {count}',
    backupSchedule: 'Щодня о 03:30 на сервері + копія на GitHub о 01:00',
    uptimeTitle: 'Доступність сайту',
    watchdogOff: 'Сторож не запущено',
    siteUp: 'Працює, відповідь {ms} мс',
    siteDown: 'Не відповідає з {since}',
    lastIncident: 'Останній простій: {at}, ~{minutes} хв',
    uptimeHint: 'Перевірка щохвилини; не відповідає 5 хв — повідомлення в Telegram',
  },
  myCompany: {
    title: 'Моя компанія',
    subtitle: 'Дані компанії, тариф, оплати та документи',
    tabs: { details: 'Дані', billing: 'Тариф і оплати', documents: 'Документи', telegram: 'Telegram-бот' },
    details: 'Реквізити',
    contacts: 'Контактна особа',
    changeHint: 'Щоб змінити дані компанії або тариф, напишіть у підтримку.',
    plan: 'Тариф',
    status: 'Статус',
    price: 'Вартість',
    nextPayment: 'Наступна оплата',
    contract: 'Договір',
    payments: 'Оплати',
  },
  placeholder: {
    title: 'Розділ у розробці',
    text: 'Цей розділ оновлюється в межах редизайну панелі.',
  },
};

export default uk;
